
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}


let GA_MEASUREMENT_ID = ''

if (process.env.NODE_ENV === 'development') {
  GA_MEASUREMENT_ID = 'UA-140875353-1'
}
if (process.env.NODE_ENV === 'test') {
  GA_MEASUREMENT_ID = 'UA-140875353-1'
}
if (process.env.NODE_ENV === 'production') {
  GA_MEASUREMENT_ID = 'UA-111711661-4'
}

// 动态加载gtag
const appendGtagJs = () => {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  head.appendChild(script);
}

export default {
  appendGtagJs,
  GA_MEASUREMENT_ID
}
